module.exports = __webpack_public_path__ + "img/11_35.06d323f6.png";